import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@mui/material';

import { ArrowLeftIcon } from 'assets/icons';

const styles = {
  icon: ({ palette }) => ({
    width: 16,
    height: 16,
    color: palette.text.secondary,
  }),
};

const ButtonBack = ({ back }) => {
  const { push, goBack } = useHistory();

  const handleClick = () => {
    if (back.to) {
      push(back.to);

      return;
    }

    goBack();
  };

  return (
    <Button
      size="small"
      id="button-back"
      disabled={back.disabled}
      onClick={handleClick}
      startIcon={<Box component={ArrowLeftIcon} sx={styles.icon} />}
    >
      Back
    </Button>
  );
};

ButtonBack.propTypes = {
  back: PropTypes.shape({
    to: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)])),
    ]),
    disabled: PropTypes.bool,
  }).isRequired,
};

export default ButtonBack;
